module.exports = __webpack_public_path__ + "static/media/gender.cc1da69d.svg";